import { serve } from '@hono/node-server'
import as from 'ansis'
import { Command } from 'commander'

import { createVoidServer } from '@scalar/void-server'

import { output } from '@/helpers/std-out'

export function VoidCommand() {
  const cmd = new Command('void')

  cmd.description('Boot a server to mirror HTTP requests')
  cmd.option('-o, --once', 'run the server only once and exit after that')
  cmd.option('-p, --port <port>', 'set the HTTP port for the mock server')
  cmd.action(
    async ({
      once,
      port,
    }: {
      watch?: boolean
      once?: boolean
      port?: number
    }) => {
      const server = await bootServer({
        port,
      })

      // Exit after the first run
      if (once) {
        setTimeout(() => {
          server.close()
        }, 2000)
      }
    },
  )

  return cmd
}

/** Start the local void server */
export const bootServer = async ({
  port,
}: {
  port?: number
}): Promise<ReturnType<typeof serve>> => {
  const app = await createVoidServer()

  return serve(
    {
      fetch: app.fetch,
      port: port ?? 3000,
    },
    (info) => {
      output
        .info()
        .line(
          `${as.green.bold('➜ Void Server')} ${as.white(
            'listening on',
          )} ${as.cyan(`http://localhost:${info.port}`)}\n`,
        )
        .print()
    },
  )
}
